import { useConversationMessageCacheHandler } from "#features/conversations/hooks/useConversationMessageCacheHandler.ts";
import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys } from "#lib/AiQueryKeys.ts";
import type { UpdateConversationMessageRatingExplanationCommand } from "#types/types.ts";
import { useMutation } from "@tanstack/react-query";

export const useUpdateConversationMessageRatingExplanationMutation = () => {
    const { updateConversationMessageRatingExplanation } = useAiApiClient();
    const { updateMessage } = useConversationMessageCacheHandler();

    return useMutation({
        mutationKey: AiMutationKeys.UpdateConversationMessageRatingExplanation(),
        mutationFn: async (payload: UpdateConversationMessageRatingExplanationCommand) => {
            await updateConversationMessageRatingExplanation(payload);
        },
        onSuccess: (_, { conversationId, conversationMessageId, explanation }) => {
            updateMessage(conversationId, conversationMessageId, message => ({
                ...message,
                rating: "bad",
                ratingExplanation: explanation
            }));
        }
    });
};
